const { connect } = require('react-redux');
const { context } = require('app-context');
const Mentions = require('../../components/Chat/Mentions');

const actions = context.actions;

module.exports = connect(
    () => ({
    }),
    (dispatch) => ({
        searchUsers: (classId, name) => {

            return dispatch(actions.dataFetching.fetchClassUserSearchResults.mentions({ classId, name }));
        }
    })
)(Mentions);
